// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__pmdo5","info":"PatientInfo_info__1KzYl"};